module.exports = __webpack_public_path__ + "static/cf-bold-ext-3287fa49d3277b65739574c198c49869.eot";